import { Navigate, Outlet, useLocation } from 'react-router';
import { useTocAcceptance } from '@/hooks/useTocAcceptance';
import { PageSpinner } from '@/components/PageSpinner';
import { ErrorState } from '@/components/ErrorState';

/**
 * Replaces TermsGuard. Behaviour difference worth knowing: the Angular guard
 * routed to /toc-acceptance whenever the check threw, so a dropped request
 * asked users to re-accept terms they had already accepted. Here a failure
 * shows an error with a retry instead, and only a definite "not accepted"
 * redirects.
 */
export function RequireTerms() {
  const location = useLocation();
  const { hasAccepted, isPending, isError, error, refetch } = useTocAcceptance();

  if (isPending) return <PageSpinner message="Checking your account..." />;

  if (isError) {
    return (
      <ErrorState
        title="Could not verify your account"
        error={error}
        onRetry={() => void refetch()}
      />
    );
  }

  if (!hasAccepted) {
    return <Navigate to="/toc-acceptance" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
